import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, TransitionGroup as _TransitionGroup, createBlock as _createBlock, Transition as _Transition, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e392f92e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user-details" }
const _hoisted_2 = { class: "callout callout--warning" }
const _hoisted_3 = { viewBox: "0 0 24 24" }
const _hoisted_4 = ["d"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { viewBox: "0 0 24 24" }
const _hoisted_8 = ["d"]
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "\"Save User\"", -1))
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "\"Save User\"", -1))
const _hoisted_13 = { viewBox: "0 0 24 24" }
const _hoisted_14 = ["d"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "We recommend using multifactor authentication (MFA) to strengthen account security. Disabling MFA will remove it from this account entirely.", -1))
const _hoisted_16 = { viewBox: "0 0 24 24" }
const _hoisted_17 = ["d"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Click \"Continue\", and then save to disable.", -1))
const _hoisted_19 = { class: "dialog-footer" }
const _hoisted_20 = { class: "d-flex justify-content-between row g-0" }
const _hoisted_21 = { class: "col text-wrap text-truncate" }
const _hoisted_22 = {
  key: 0,
  style: {"display":"inline-block"}
}
const _hoisted_23 = {
  class: "new-name",
  key: "noname"
}
const _hoisted_24 = { class: "col-auto ms-auto align-self-end align-self-sm-start me-sm-2" }
const _hoisted_25 = { class: "mt-sm-0 d-flex col-sm-auto mt-2 col-12 col-sm-auto" }
const _hoisted_26 = { class: "ms-auto" }
const _hoisted_27 = {
  key: 0,
  class: "callout callout--warning callout--in-content"
}
const _hoisted_28 = { viewBox: "0 0 24 24" }
const _hoisted_29 = ["d"]
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { key: 1 }
const _hoisted_32 = { viewBox: "0 0 24 24" }
const _hoisted_33 = ["d"]
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { key: 1 }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "\"Save User\"", -1))
const _hoisted_37 = { viewBox: "0 0 24 24" }
const _hoisted_38 = ["d"]
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "We recommend using multifactor authentication (MFA) to strengthen account security. Disabling MFA will remove it from this account entirely.", -1))
const _hoisted_40 = { viewBox: "0 0 24 24" }
const _hoisted_41 = ["d"]
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Click \"Continue\", and then save to disable.", -1))
const _hoisted_43 = { class: "dt-container" }
const _hoisted_44 = { key: 0 }
const _hoisted_45 = { class: "row" }
const _hoisted_46 = { class: "col-md-6 p-0 pe-md-2" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Name of this user", -1))
const _hoisted_48 = { class: "col-md-6 p-0 ps-md-2" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "el-form-item__label" }, "Email Address", -1))
const _hoisted_50 = {
  key: 1,
  class: "ms-2",
  "aria-hidden": "true"
}
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Email address of this user", -1))
const _hoisted_52 = { class: "row" }
const _hoisted_53 = {
  key: 0,
  class: "col-md-6 p-0 pe-md-2 transition"
}
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Assigned role for this user", -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", null, "Contact your Ditto account admin to change your role.")
], -1))
const _hoisted_56 = {
  key: 0,
  class: "transition col-md-6 p-0 ps-md-2"
}
const _hoisted_57 = { key: 0 }
const _hoisted_58 = { key: 1 }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Multifactor Authentication", -1))
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "User will be required to set up MFA application on mobile device", -1))
const _hoisted_61 = { class: "row" }
const _hoisted_62 = {
  key: 0,
  class: "col-md-6 p-0 pe-md-2 transition"
}
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "An email will be sent", -1))
const _hoisted_64 = { key: 0 }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Show Release Notification", -1))
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Show animated notification dot on release notes icon.", -1))
const _hoisted_67 = { class: "col-md-6 p-0 ps-md-2" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "el-form-item__label" }, "Authentication Data", -1))
const _hoisted_69 = { class: "d-flex flex-column gap-3" }
const _hoisted_70 = { class: "d-flex align-items-center gap-2" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Email: ", -1))
const _hoisted_72 = {
  style: {"width":"20px","height":"20px"},
  viewBox: "0 0 24 24"
}
const _hoisted_73 = {
  key: 0,
  class: "primary-color",
  d: "M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"
}
const _hoisted_74 = {
  key: 1,
  class: "red",
  d: "M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
}
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Last Login: ", -1))
const _hoisted_76 = { class: "d-flex align-items-center gap-2" }
const _hoisted_77 = { class: "flex-grow-1" }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Created: ", -1))
const _hoisted_79 = { class: "flex-grow-1" }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Updated: ", -1))
const _hoisted_81 = { class: "d-flex align-items-center gap-2" }
const _hoisted_82 = { class: "flex-grow-1 overflow" }
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Org ID: ", -1))
const _hoisted_84 = { key: 0 }
const _hoisted_85 = { class: "flex-grow-1 overflow" }
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "User ID: ", -1))
const _hoisted_87 = { key: 0 }
const _hoisted_88 = { class: "overflow" }
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Ditto Signature: ", -1))
const _hoisted_90 = { key: 0 }
const _hoisted_91 = { class: "row" }
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "All onboardings currently in progress by the user.", -1))
const _hoisted_93 = { class: "user__onboarding-title" }
const _hoisted_94 = {
  key: 0,
  class: "dt-tag"
}
const _hoisted_95 = {
  key: 1,
  class: "dt-tag--exit"
}
const _hoisted_96 = {
  key: 2,
  class: "dt-tag--plain"
}
const _hoisted_97 = { class: "d-flex flex-column gap-3" }
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "ID", -1))
const _hoisted_99 = ["onClick"]
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 24 24" }, [
  /*#__PURE__*/_createElementVNode("path", { d: "M19,21H8V7H19M19,5H8A2,2 0 0,0 6,7V21A2,2 0 0,0 8,23H19A2,2 0 0,0 21,21V7A2,2 0 0,0 19,5M16,1H4A2,2 0 0,0 2,3V17H4V3H16V1Z" })
], -1))
const _hoisted_101 = [
  _hoisted_100
]
const _hoisted_102 = { class: "d-flex align-items-center gap-2" }
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Step", -1))
const _hoisted_104 = { key: 0 }
const _hoisted_105 = { key: 1 }
const _hoisted_106 = { key: 2 }
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Created at", -1))
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Browser Info", -1))
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Don't Show Again", -1))
const _hoisted_110 = {
  key: 1,
  class: "user__no-onboardings"
}
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h3", { class: "m-0" }, "User Actions")
], -1))
const _hoisted_112 = { class: "user__drawer-list" }
const _hoisted_113 = { class: "d-flex flex-column gap-1" }
const _hoisted_114 = { class: "user__drawer-action-details" }
const _hoisted_115 = {
  key: 0,
  class: "d-inline-flex align-items-center gap-1"
}
const _hoisted_116 = {
  style: {"width":"14px","height":"14px"},
  viewBox: "0 0 24 24"
}
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z" }, null, -1))
const _hoisted_118 = [
  _hoisted_117
]
const _hoisted_119 = { class: "user__drawer-action-date" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_dialog, {
      title: (_ctx.userOriginalCopyMFA ? 'Disable' : 'Enable') + ' Multifactor Authentication',
      modelValue: _ctx.mfaModalVisible,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.mfaModalVisible) = $event)),
      center: ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_19, [
          _createVNode(_component_el_button, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.mfaModalVisible = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Cancel")
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.continueMfaModalHandler
          }, {
            default: _withCtx(() => [
              _createTextVNode("Continue")
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("ul", _hoisted_2, [
          (!_ctx.userOriginalCopyMFA)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("li", null, [
                  (_openBlock(), _createElementBlock("svg", _hoisted_3, [
                    _createElementVNode("path", { d: _ctx.mdiAlertCircleOutline }, null, 8, _hoisted_4)
                  ])),
                  (_ctx.isMe)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_5, "To complete setup, you will need a mobile device with a multifactor authentication (MFA) app, such as Google Authenticator."))
                    : (_openBlock(), _createElementBlock("span", _hoisted_6, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.user.name), 1),
                        _createTextVNode(" will need a mobile device with a multifactor authentication (MFA) app, such as Google Authenticator, to complete MFA setup and log in again.")
                      ]))
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createElementBlock("svg", _hoisted_7, [
                    _createElementVNode("path", { d: _ctx.mdiAlertCircleOutline }, null, 8, _hoisted_8)
                  ])),
                  (_ctx.isMe)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                        _createTextVNode("To enable MFA, you must click "),
                        _hoisted_10,
                        _createTextVNode(" & log out.")
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_11, [
                        _createTextVNode("To enable MFA, you must click "),
                        _hoisted_12,
                        _createTextVNode(". "),
                        _createElementVNode("strong", null, _toDisplayString(_ctx.user.name), 1),
                        _createTextVNode(" will be logged out of the Ditto account portal immediately.")
                      ]))
                ])
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("li", null, [
                  (_openBlock(), _createElementBlock("svg", _hoisted_13, [
                    _createElementVNode("path", { d: _ctx.mdiAlertCircleOutline }, null, 8, _hoisted_14)
                  ])),
                  _hoisted_15
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createElementBlock("svg", _hoisted_16, [
                    _createElementVNode("path", { d: _ctx.mdiAlertCircleOutline }, null, 8, _hoisted_17)
                  ])),
                  _hoisted_18
                ])
              ], 64))
        ])
      ]),
      _: 1
    }, 8, ["title", "modelValue"]),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("h1", _hoisted_21, [
        (_ctx.isMe)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(_component_router_link, {
                class: "primary-color",
                to: "/admin/users"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Users")
                ]),
                _: 1
              }),
              _createTextVNode(" » "),
              _createVNode(_Transition, {
                name: "fade-in",
                mode: "out-in"
              }, {
                default: _withCtx(() => [
                  (_ctx.user.name)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        _createVNode(_TransitionGroup, {
                          class: "transition",
                          name: _ctx.user.name.length > 1 ? 'fade-in' : '',
                          key: "name"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.user.name, (letter, i) => {
                              return (_openBlock(), _createElementBlock("span", {
                                class: "transition",
                                key: i
                              }, _toDisplayString(letter), 1))
                            }), 128)),
                            _createTextVNode(" " + _toDisplayString(_ctx.user.isSSOGenerated ? '(SSO)' : ''), 1)
                          ]),
                          _: 1
                        }, 8, ["name"]),
                        (_ctx.user && _ctx.user.organization)
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 0,
                              class: "primary-color",
                              to: `/admin/organizations/${_ctx.user.organization.id}`
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" (org)")
                              ]),
                              _: 1
                            }, 8, ["to"]))
                          : _createCommentVNode("", true)
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_23, " User name "))
                ]),
                _: 1
              })
            ], 64))
      ]),
      _createElementVNode("div", _hoisted_24, [
        _createVNode(_component_el_button, { onClick: _ctx.onCancel }, {
          default: _withCtx(() => [
            _createTextVNode("Cancel")
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          _createVNode(_component_el_button, {
            onClick: _ctx.onSave,
            type: "primary",
            disabled: _ctx.saving
          }, {
            default: _withCtx(() => [
              false
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode("Create ")
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(_ctx.creationMode ? 'Create' : 'Save'), 1)
                  ], 64)),
              _createTextVNode(" User ")
            ]),
            _: 1
          }, 8, ["onClick", "disabled"])
        ])
      ])
    ]),
    (_ctx.warningHasChanged)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_27, [
          (!_ctx.userOriginalCopyMFA)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("li", null, [
                  (_openBlock(), _createElementBlock("svg", _hoisted_28, [
                    _createElementVNode("path", { d: _ctx.mdiAlertCircleOutline }, null, 8, _hoisted_29)
                  ])),
                  (_ctx.isMe)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_30, "To complete setup, you will need a mobile device with a multifactor authentication (MFA) app, such as Google Authenticator."))
                    : (_openBlock(), _createElementBlock("span", _hoisted_31, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.user.name), 1),
                        _createTextVNode(" will need a mobile device with a multifactor authentication (MFA) app, such as Google Authenticator, to complete MFA setup and log in again.")
                      ]))
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createElementBlock("svg", _hoisted_32, [
                    _createElementVNode("path", { d: _ctx.mdiAlertCircleOutline }, null, 8, _hoisted_33)
                  ])),
                  (_ctx.isMe)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_34, "To enable MFA, you must click \"Save User\" & log out."))
                    : (_openBlock(), _createElementBlock("span", _hoisted_35, [
                        _createTextVNode("To enable MFA, you must click "),
                        _hoisted_36,
                        _createTextVNode(". "),
                        _createElementVNode("strong", null, _toDisplayString(_ctx.user.name), 1),
                        _createTextVNode(" will be logged out of the Ditto account portal immediately.")
                      ]))
                ])
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("li", null, [
                  (_openBlock(), _createElementBlock("svg", _hoisted_37, [
                    _createElementVNode("path", { d: _ctx.mdiAlertCircleOutline }, null, 8, _hoisted_38)
                  ])),
                  _hoisted_39
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createElementBlock("svg", _hoisted_40, [
                    _createElementVNode("path", { d: _ctx.mdiAlertCircleOutline }, null, 8, _hoisted_41)
                  ])),
                  _hoisted_42
                ])
              ], 64))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_43, [
      (_ctx.creationMode)
        ? (_openBlock(), _createElementBlock("p", _hoisted_44, "To give someone access to the Ditto Settings Portal, add them as a user below. This person will be able to edit Ditto account settings."))
        : _createCommentVNode("", true),
      _createVNode(_component_el_form, {
        model: _ctx.user,
        "hide-required-asterisk": "",
        ref: "userForm",
        "label-position": "top",
        rules: _ctx.rules
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("div", _hoisted_46, [
              _createVNode(_component_el_form_item, {
                label: "Name",
                prop: "name"
              }, {
                default: _withCtx(() => [
                  _hoisted_47,
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.user.name,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.user.name) = $event)),
                    placeholder: "User Name",
                    disabled: _ctx.user.isSSOGenerated
                  }, null, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_48, [
              _createVNode(_component_el_form_item, { prop: "email" }, {
                default: _withCtx(() => [
                  _createElementVNode("label", null, [
                    _hoisted_49,
                    (!_ctx.user.isSSOGenerated && !_ctx.user.is_verified && !_ctx.creationMode)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: "el-form-item__subtitle-link",
                          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onResendVerificationEmail && _ctx.onResendVerificationEmail(...args)))
                        }, _toDisplayString(_ctx.resendingVerificationEmail ? 'Sending...' : 'Resend Verification Email'), 1))
                      : _createCommentVNode("", true),
                    (_ctx.resendingVerificationEmail)
                      ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_50, null, 512)), [
                          [_directive_loading, _ctx.resendingVerificationEmail]
                        ])
                      : _createCommentVNode("", true)
                  ]),
                  _hoisted_51,
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.user.email,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.user.email) = $event)),
                    placeholder: "Email",
                    onChange: _ctx.emailChanged,
                    disabled: _ctx.user.isSSOGenerated
                  }, null, 8, ["modelValue", "onChange", "disabled"])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_52, [
            _createVNode(_Transition, { name: "slide-in-top-large" }, {
              default: _withCtx(() => [
                (!_ctx.creationMode)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                      _createVNode(_component_el_form_item, {
                        prop: "roleName",
                        label: "Role"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_54,
                          _createVNode(_component_el_tooltip, {
                            placement: "top",
                            disabled: false
                          }, {
                            content: _withCtx(() => [
                              _hoisted_55
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                disabled: false,
                                filterable: "",
                                modelValue: _ctx.user.role,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.user.role) = $event)),
                                "value-key": "id"
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allRoles, (role) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: role.id,
                                      label: role.name,
                                      value: role.id
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(role.name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            (!_ctx.creationMode)
              ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                  _createVNode(_component_el_form_item, { prop: "MFA" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_tooltip, {
                        "show-after": 250,
                        "hide-after": 0,
                        placement: "top",
                        disabled: (!_ctx.user.ownerSetMFA || _ctx.isAdmin) && _ctx.user.is_verified
                      }, {
                        content: _withCtx(() => [
                          (_ctx.user.ownerSetMFA && _ctx.isMe)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                                _createElementVNode("p", null, "MFA " + _toDisplayString(_ctx.user.MFA ? 'enabled' : 'disabled') + " by a Ditto Account Portal administrator.", 1),
                                _createElementVNode("p", null, [
                                  _createElementVNode("em", null, "Contact your IT department if you wish to " + _toDisplayString(_ctx.user.MFA ? 'disable' : 'enable') + " it.", 1)
                                ])
                              ]))
                            : (!_ctx.user.is_verified)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_58, " MFA can only be enabled for verified users. "))
                              : _createCommentVNode("", true)
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("label", {
                            class: _normalizeClass({ disabled : (_ctx.user.ownerSetMFA && !_ctx.isAdmin) || !_ctx.user.is_verified })
                          }, [
                            _createVNode(_component_el_switch, {
                              disabled: _ctx.user.isSSOGenerated || (_ctx.user.ownerSetMFA && !_ctx.isAdmin) || !_ctx.user.is_verified,
                              onInput: _ctx.mfaInputHandler,
                              value: _ctx.user.MFA
                            }, null, 8, ["disabled", "onInput", "value"]),
                            _hoisted_59
                          ], 2)
                        ]),
                        _: 1
                      }, 8, ["disabled"]),
                      _hoisted_60
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_61, [
            _createVNode(_Transition, { name: "slide-in-top-large" }, {
              default: _withCtx(() => [
                (!_ctx.creationMode)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                      _createVNode(_component_el_form_item, { label: "Reset Password" }, {
                        default: _withCtx(() => [
                          _hoisted_63,
                          _createVNode(_component_el_button, {
                            onClick: _ctx.onResetPassword,
                            disabled: _ctx.user.isSSOGenerated
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Reset Password")
                            ]),
                            _: 1
                          }, 8, ["onClick", "disabled"])
                        ]),
                        _: 1
                      }),
                      (!_ctx.creationMode && _ctx.showOnboardingButton)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                            _createVNode(_component_el_form_item, {
                              class: "ditto-setup-tutorial",
                              label: "Ditto Setup Tutorial"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", null, _toDisplayString(_ctx.tutorialText), 1),
                                _createVNode(_component_el_button, { onClick: _ctx.onStartOnboarding }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Ditto Setup Tutorial")
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { prop: "showReleaseNotification" }, {
                              default: _withCtx(() => [
                                _createElementVNode("label", null, [
                                  _createVNode(_component_el_switch, {
                                    modelValue: _ctx.user.showReleaseNotification,
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.user.showReleaseNotification) = $event))
                                  }, null, 8, ["modelValue"]),
                                  _hoisted_65
                                ]),
                                _hoisted_66
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_67, [
              _createVNode(_component_el_form_item, { prop: "authenticationData" }, {
                default: _withCtx(() => [
                  _createElementVNode("label", null, [
                    _hoisted_68,
                    _createVNode(_component_el_tooltip, {
                      content: "Re-Generate Ditto Signature",
                      "show-after": 0,
                      "hide-after": 250,
                      placement: "top"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("button", {
                          onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onGenerateSignature && _ctx.onGenerateSignature(...args))),
                          class: "dt-icon-button ms-2"
                        }, [
                          _createVNode(_component_Icon, { icon: _ctx.mdiRefresh }, null, 8, ["icon"])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_69, [
                    _createElementVNode("div", null, [
                      _createElementVNode("span", _hoisted_70, [
                        _createElementVNode("span", null, [
                          _hoisted_71,
                          _createTextVNode(" " + _toDisplayString(_ctx.auth0UserData.email), 1)
                        ]),
                        _createVNode(_component_el_tooltip, {
                          content: _ctx.auth0UserData.email_verified ? 'Verified' : 'Not Verified',
                          "show-after": 250,
                          "hide-after": 250,
                          placement: "top"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", null, [
                              (_openBlock(), _createElementBlock("svg", _hoisted_72, [
                                (_ctx.auth0UserData.email_verified)
                                  ? (_openBlock(), _createElementBlock("path", _hoisted_73))
                                  : (_openBlock(), _createElementBlock("path", _hoisted_74))
                              ]))
                            ])
                          ]),
                          _: 1
                        }, 8, ["content"])
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("span", null, [
                        _hoisted_75,
                        _createTextVNode(_toDisplayString(new Date(_ctx.auth0UserData.last_login as string).toLocaleString()) + " - ", 1),
                        _createElementVNode("em", null, _toDisplayString(_ctx.auth0UserData.logins_count) + " logins", 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_76, [
                      _createElementVNode("div", _hoisted_77, [
                        _createElementVNode("span", null, [
                          _hoisted_78,
                          _createTextVNode(_toDisplayString(new Date(_ctx.auth0UserData.created_at as string).toLocaleString()), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_79, [
                        _createElementVNode("span", null, [
                          _hoisted_80,
                          _createTextVNode(_toDisplayString(new Date(_ctx.auth0UserData.updated_at as string).toLocaleString()), 1)
                        ])
                      ])
                    ]),
                    (_ctx.auth0UserData)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("div", _hoisted_81, [
                            _createElementVNode("div", _hoisted_82, [
                              _createElementVNode("span", null, [
                                _hoisted_83,
                                (_ctx.auth0UserData.app_metadata)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_84, _toDisplayString(_ctx.auth0UserData.app_metadata.ditto_org_id), 1))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_85, [
                              _createElementVNode("span", null, [
                                _hoisted_86,
                                (_ctx.auth0UserData.app_metadata)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_87, _toDisplayString(_ctx.auth0UserData.app_metadata.ditto_user_id), 1))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_88, [
                            _createElementVNode("span", null, [
                              _hoisted_89,
                              (_ctx.auth0UserData.app_metadata)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_90, _toDisplayString(_ctx.auth0UserData.app_metadata.ditto_signature), 1))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ], 64))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_91, [
            _createVNode(_component_el_form_item, {
              class: "p-0 mb-0",
              label: "Current Onboardings",
              prop: "onboardings"
            }, {
              default: _withCtx(() => [
                _hoisted_92,
                (_ctx.onboardings && _ctx.onboardings.data && _ctx.onboardings.data.length)
                  ? (_openBlock(), _createBlock(_component_el_collapse, {
                      key: 0,
                      modelValue: _ctx.activeOnboardingCollapse,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.activeOnboardingCollapse) = $event))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.onboardings.data, (onboarding, i) => {
                          return (_openBlock(), _createBlock(_component_el_collapse_item, {
                            key: i,
                            name: i
                          }, {
                            title: _withCtx(() => [
                              _createElementVNode("div", _hoisted_93, [
                                _createElementVNode("span", null, _toDisplayString(onboarding.id), 1),
                                (onboarding.step === 18)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_94, "Completed"))
                                  : (onboarding.dontShowAgain)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_95, "Early Exit"))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_96, "Active"))
                              ])
                            ]),
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_97, [
                                _createElementVNode("div", null, [
                                  _createElementVNode("span", null, [
                                    _hoisted_98,
                                    _createTextVNode(": " + _toDisplayString(onboarding.id), 1)
                                  ]),
                                  _createElementVNode("button", {
                                    onClick: _withModifiers(($event: any) => (_ctx.copyToClipboard(onboarding.id)), ["stop","prevent"]),
                                    class: "dt-icon-button ms-2"
                                  }, _hoisted_101, 8, _hoisted_99)
                                ]),
                                _createElementVNode("div", _hoisted_102, [
                                  _createElementVNode("span", null, [
                                    _hoisted_103,
                                    _createTextVNode(": "),
                                    (onboarding.step)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_104, _toDisplayString(onboarding.step), 1))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_105, "No user actions")),
                                    _createTextVNode(),
                                    (_ctx.getStepDetails(onboarding.step))
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_106, " - " + _toDisplayString(`${_ctx.getStepDetails(onboarding.step).category} > ${_ctx.getStepDetails(onboarding.step).name}`), 1))
                                      : _createCommentVNode("", true)
                                  ]),
                                  (onboarding.userActions)
                                    ? (_openBlock(), _createBlock(_component_el_button, {
                                        key: 0,
                                        onClick: ($event: any) => (_ctx.currentUserActions =  onboarding.userActions),
                                        size: "small",
                                        type: "primary",
                                        plain: "",
                                        class: "ms-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("View Actions "),
                                          _createElementVNode("span", null, "(" + _toDisplayString(onboarding.userActions.length) + ")", 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", null, [
                                  _createElementVNode("span", null, [
                                    _hoisted_107,
                                    _createTextVNode(": " + _toDisplayString(onboarding.createdAt), 1)
                                  ])
                                ]),
                                _createElementVNode("div", null, [
                                  _createElementVNode("span", null, [
                                    _hoisted_108,
                                    _createTextVNode(": " + _toDisplayString(onboarding.browserInfo), 1)
                                  ])
                                ]),
                                _createElementVNode("div", null, [
                                  _createElementVNode("span", null, [
                                    _hoisted_109,
                                    _createTextVNode(": " + _toDisplayString(onboarding.dontShowAgain), 1)
                                  ])
                                ])
                              ])
                            ]),
                            _: 2
                          }, 1032, ["name"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"]))
                  : (_openBlock(), _createElementBlock("p", _hoisted_110, "No onboardings in progress"))
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _createVNode(_component_el_drawer, {
      modelValue: _ctx.currentUserActions,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.currentUserActions) = $event)),
      title: "User Actions",
      direction: "rtl",
      "before-close": _ctx.handleClose,
      "custom-class": "user__actions-drawer"
    }, {
      title: _withCtx(() => [
        _hoisted_111
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("ol", _hoisted_112, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentUserActions, (action, i) => {
              return (_openBlock(), _createElementBlock("li", { key: i }, [
                _createElementVNode("div", _hoisted_113, [
                  _createElementVNode("div", _hoisted_114, [
                    _createElementVNode("strong", null, _toDisplayString(i + 1) + ". ", 1),
                    (_ctx.getActionDetails(action))
                      ? (_openBlock(), _createElementBlock("strong", _hoisted_115, [
                          _createTextVNode(_toDisplayString(_ctx.getActionDetails(action).category) + " ", 1),
                          (_openBlock(), _createElementBlock("svg", _hoisted_116, _hoisted_118)),
                          _createTextVNode(" " + _toDisplayString(_ctx.getActionDetails(action).name), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("em", null, " - " + _toDisplayString(action.actionDescription), 1)
                  ]),
                  _createElementVNode("span", _hoisted_119, _toDisplayString(new Date(action.createdAt).toLocaleString()), 1)
                ])
              ]))
            }), 128))
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "before-close"])
  ])), [
    [_directive_loading, _ctx.loading]
  ])
}